import { AddTrainingClassRequest } from './add.training.class.request';

export class UpdateTrainingClassRequest extends AddTrainingClassRequest {
    ClassID: number;
}
